import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import AlertsPage from './pages/AlertsPage';
import MyAlertsPage from './pages/MyAlertsPage';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/search" element={<SearchPage data-id="element-8" />} data-id="element-7" />
            <Route path="/alerts" element={<AlertsPage data-id="element-10" />} data-id="element-9" />
            <Route path="/my-alerts" element={<MyAlertsPage data-id="element-12" />} data-id="element-11" />
          </Routes>
        </main>
        <Footer data-id="element-13" />
      </div>
    </Router>;
}